import * as React from 'react';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import { Layout as SettingsLayout } from '@/layouts/v2/settings/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { UserBasicDetails } from '@/pages/v2/settings/user-basic-details';
import { UserPaymentSettings } from '@/pages/v2/settings/user-payment-settings';
import { UserSecuritySettings } from '@/pages/v2/settings/user-security-settings';

export const route: RouteObject = {
  path: paths.settings.profile.account,
  element: (
    <DashboardLayout>
      <SettingsLayout metadata={{ title: 'Settings' }}>
        <Outlet />
      </SettingsLayout>
    </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: <UserBasicDetails />,
    },
    {
      path: 'payments',
      element: <UserPaymentSettings />,
    },
    {
      path: 'security',
      element: <UserSecuritySettings />,
    },
  ],
};
